import CustomButton from "../../../../components/CustomButton";
import CarTagView from "../../../../components/CarTag";
import { Box, Typography, useTheme } from "@mui/material";
import DolorGreen from "../../../../../media/images/icons/dolor-green";
import DolorTimer from "../../../../../media/images/icons/dolor-timer";
import { blueGrey } from "@mui/material/colors";
import profileImage from "../../../../../media/images/profileImage.svg";
import PhoneOutlineSVG from "../../../../../media/images/icons/phone-outline";
import { Link } from "react-router-dom";

export default function DriverInfoBox() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        mt: 2,
        boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
        display: "flex",
        borderColor: "info.main",
        borderStyle: "solid",
        gap: "4px",
        borderWidth: "1px",
        borderRadius: "16px",
        flexDirection: "column",
        padding: "8px",
        backgroundColor: "background.default",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <DolorGreen size={26} color={theme.palette.textColor.main} />
          <Typography
            sx={{
              fontSize: "16px",
              color: "textColor.main",
              fontWeight: "700",
            }}
          >
            کرایه بار:
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
              color: theme.palette.secondary[600],
            }}
          >
            80,000,000 ریال
          </Typography>
        </Box>
        <CustomButton
          rippleColor={theme.palette.info.dark}
          // loading
          flexDirection="row-reverse"
          //   onClick={() => handleEditModal()}
          title="پرداخت کرایه "
          bgColor="secondary.main"
          textColor="#fff"
          px="12px"
          py="8px"
          borderRadius="6px"
          icon1={<DolorTimer size={22} color={"#fff"} />}
        />
      </Box>

      <Box
        sx={{
          border: "1px solid",
          borderColor: blueGrey[100],
          padding: "4px 8px",
          borderRadius: "8px",
          backgroundColor: "bgColor.white",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              width={32}
              height={32}
              style={{
                borderRadius: "50%",
              }}
              src={profileImage}
              alt=""
            />
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              رضا یعقوبی‌فریان پور
            </Typography>
          </Box>
          <CarTagView />
        </Box>

        <Link
          to={"tel:01254545"}
          style={{
            marginTop: "4px",
            gap: "4px",
            backgroundColor: theme.palette.primary[50],
            border: "1px solid",
            borderColor: theme.palette.primary.main,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "8px 12px",
            borderRadius: "5px",
          }}
        >
          <PhoneOutlineSVG size={22} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "14px",
              color: "primary.main",
            }}
          >
            تماس با راننده
          </Typography>
        </Link>

        {/* <CustomButton
          width="100%"
          rippleColor={theme.palette.info.dark}
          // loading
          justifyContent="center"
          onClick={() => navigate("tel:01254545")}
          title="تماس با راننده"
          bgColor="primary.light"
          textColor="primary.main"
          borderColor="info.dark"
          // fontWeight={700}
          px="10px"
          py="12px"
          mt="8px"
          borderRadius="6px"
          icon1={
            <PhoneOutlineSVG size={22} color={theme.palette.primary.main} />
          }
        /> */}
      </Box>
    </Box>
  );
}
